import { render, staticRenderFns } from "./EditDrawer.vue?vue&type=template&id=3caea671&scoped=true"
import script from "./EditDrawer.vue?vue&type=script&lang=js"
export * from "./EditDrawer.vue?vue&type=script&lang=js"
import style0 from "./EditDrawer.vue?vue&type=style&index=0&id=3caea671&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caea671",
  null
  
)

export default component.exports